import { cn } from '@/lib/utils';

interface SystemProcessingIndicatorProps {
  className?: string;
}

/**
 * HUD-style "System Processing" animation.
 * Replaces generic typing dots with a scanning bar effect.
 */
export function SystemProcessingIndicator({ className }: SystemProcessingIndicatorProps) {
  return (
    <div className={cn('flex gap-3 animate-fade-up', className)}>
      {/* Coach avatar placeholder */}
      <div className="w-8 h-8 rounded-full bg-white/[0.05] border border-[#00FFC8]/30 flex items-center justify-center shrink-0">
        <div className="w-2 h-2 rounded-full bg-[#00FFC8] animate-pulse" />
      </div>

      {/* Scanning bar */}
      <div className="rounded-lg px-4 py-3 bg-white/[0.03] border border-white/[0.08] backdrop-blur-sm">
        <div className="flex items-center gap-3">
          {/* Status text */}
          <span className="font-mono text-[10px] uppercase tracking-[0.1em] text-[#00FFC8]/70">
            System Processing
          </span>

          {/* Scanning bar animation */}
          <div className="relative w-24 h-[3px] bg-white/[0.06] rounded-full overflow-hidden">
            <div
              className="absolute top-0 left-0 h-full w-8 rounded-full"
              style={{
                background: 'linear-gradient(90deg, transparent, #00FFC8, transparent)',
                animation: 'scan-sweep 1.4s ease-in-out infinite',
              }}
            />
          </div>

          {/* Blinking cursor */}
          <span
            className="w-[2px] h-3 bg-[#00FFC8]/80"
            style={{ animation: 'cursor-blink 0.8s step-end infinite' }}
          />
        </div>
      </div>

      <style>{`
        @keyframes scan-sweep {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(400%); }
        }
        @keyframes cursor-blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }
      `}</style>
    </div>
  );
}
